import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import "./style.scss"

function NotEnoughData({ portfolio, account, isOpPro }) {
  return <div className="components_not-enough-data">
    <h2>Performance not available for this portfolio with limited dates</h2>
    <p>This portfolio has limited uploaded data that may cause certain features to not display correctly. For example, cumulative performance requires a portfolio with 2+ dates to work properly.</p>
    <p>Please consider <Link to={`/${account}/p/${portfolio}/upload`}>uploading more dates</Link>, and/or setting this portfolio to rollover positions to current date.</p>
    <p>{!isOpPro && <><Link to={`/${account}/p/${portfolio}/analyze/risk`}>Risk</Link> and </>}<Link to={`/${account}/p/${portfolio}/analyze/exposure`}>Exposure</Link> information is available for this portfolio.</p>
  </div>
}

NotEnoughData.propTypes = {
  portfolio: PropTypes.string.isRequired,
  account: PropTypes.string.isRequired,
  isOpPro: PropTypes.bool.isRequired,
}

export default NotEnoughData
